import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useMovieActivityContext } from "src/components/film/filmwebid/MovieActivityContextTypes";
import { emptyMovieActivity, type IMovieActivity } from "src/lib/filmwebid/IMovieActivity";
import type { UserApiQueryKey } from "src/lib/filmwebid/useUserApiQuery";
export function useMovieActivityOptimisticUpdater(queryKey) {
  const $ = _c(4);
  const queryClient = useQueryClient();
  const {
    optimisticUpdater
  } = useMovieActivityContext();
  let t0;
  if ($[0] !== optimisticUpdater || $[1] !== queryClient || $[2] !== queryKey) {
    t0 = async updater => {
      const previousData = queryClient.getQueryData(queryKey);
      await queryClient.cancelQueries({
        queryKey
      });
      optimisticUpdater(old => updater(old ?? emptyMovieActivity));
      return {
        previousData
      };
    };
    $[0] = optimisticUpdater;
    $[1] = queryClient;
    $[2] = queryKey;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}